// minify されたビルドでは Sentry に「Error: Aa」のような解決不能なイベントのみが残るため、
// スタックトレースが解決できない場合でも切り分けができるよう診断情報を付与する。
export type ErrorDiagnostics = {
  errorName: string;
  errorMessage: string;
  hasStack: boolean;
  stackFrameCount: number;
  componentStack?: string;
};

function countStackFrames(stack: string): number {
  return stack.split('\n').filter((line) => line.trim() !== '').length;
}

export function buildErrorDiagnostics(
  error: unknown,
  componentStack?: string | null
): ErrorDiagnostics {
  const stack = error instanceof Error ? error.stack : undefined;

  return {
    errorName: error instanceof Error ? error.name : typeof error,
    errorMessage: error instanceof Error ? error.message : String(error),
    hasStack: !!stack,
    stackFrameCount: stack ? countStackFrames(stack) : 0,
    componentStack: componentStack ?? undefined,
  };
}
